import HttpHelper from "./http";
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/store/modules/user';
import store from '@/store';
import localforage from 'localforage';
import UUIDHelper from "./uuid";

export enum EAnalyticsProduct {
  streamlabsStudio = 'streamlabs-console',
}

export enum EAnalyticsEvent {
  getStartedButtonClicked = 'Get Started Button Clicked',
  landingLoaded = 'Landing Loaded',
  loginButtonClicked = 'Login Button Clicked',
  signUpButtonClicked = 'Sign Up Button Clicked',
  projectCreated = 'Project Created',
  projectDeleted = 'Project Deleted',
  sceneCreated = 'Scene Created',
  sceneDeleted = 'Scene Deleted',
  themeAdded = 'Theme Added',
  transitionAdded = 'Transition Added',
  streamlabsConnected = 'Streamlabs Connected',
  goLive = 'Go Live',
  streamSettings = 'Stream Settings',
  layerSettings = 'Layer Settings',
  webcamAdded = 'Webcam Added',
  webcamRemoved = 'Webcam Removed',
  streamlabsWidgetAdded = 'Streamlabs Widget Added',
  streamlabsWidgetRemoved = 'Streamlabs Widget Removed',
  otherComponentAdded = 'Other Component Added',
  otherComponentRemoved = 'Other Component Removed',
  activeSceneChanged = 'Active Scene Changed',
  paymentInfo = 'Payment Info',
  checkoutModalOpened = 'Checkout Modal Opened',
  checkoutModalClosed = 'Checkout Modal Closed',
  ultraBannerShown = 'Ultra Banner Shown',
  ultraBannerClicked = 'Ultra Banner Clicked',
  ultraBannerSuccess = 'Ultra Banner Success',
  ultraBannerFailure = 'Ultra Banner Failure',

  slNativeLanding = 'SL Native Landing',
  slNativeLoginLanding = 'SL Native Login Landing',
  slNativeSignupLanding = 'SL Native Signup Landing',
  slNativeSessionLanding = 'SL Native Session Landing',
  slNativeLoginAttempt = 'SL Native Login Attempt',
  slNativeLoginSuccess = 'SL Native Login Success',
  slNativeLoginFailure = 'SL Native Login Failure',
  slNativeOnPlatformClick = 'SL Native On Platform Click',
  slNativeExit = 'SL Native Exit',

  impression = 'Impression',
  checkoutImpression = 'Checkout Impression',
  checkoutAttempt = 'Checkout Attempt',
  checkoutSuccess = 'Checkout Success',
  checkoutError = 'Checkout Error',
  checkoutUltraClicked = 'Checkout Ultra Clicked',

  checkoutImpressionFreeTrial = 'Checkout Impression Free Trial',
  checkoutAttemptFreeTrial = 'Checkout Attempt Free Trial',
  checkoutSuccessFreeTrial = 'Checkout Success Free Trial',
  checkoutErrorFreeTrial = 'Checkout Error Free Trial',
  checkoutUltraClickedFreeTrial = 'Checkout Ultra Clicked Free Trial',

  subscriptionCanceled = 'Subscription Canceled',
  unhandleSocketEvent = 'Unhandle Socket Event',
  peerConnectionError = 'Peer Connection Error',
}

const ANALYTICS_UUID_KEY = 'analytics-uuid';

interface IEventData {
  event: EAnalyticsEvent;
  product: EAnalyticsProduct;
  value: object;
  version: number;
  count: number;
  uuid: string;
  user_id?: number;
}

export default class AnalyticHelper {
  static userModule = getModule(UserModule, store);
  static uuid: string = null;

  static get host(): string {
    return 'https://r2d2.streamlabs.com';
  }

  static get analyticProjectId(): string {
    return process.env.MIX_ANALYTIC_PROJECT_ID;
  }

  static get endpoint(): string {
    return `${this.host}/projects/${this.analyticProjectId}/data/ping`;
  }

  static async getUuid(): Promise<string> {
    if (this.uuid) return this.uuid;

    let uuid: string | number = await localforage.getItem<string>(ANALYTICS_UUID_KEY);

    if (!uuid) {
      uuid = UUIDHelper.create();
      await localforage.setItem(ANALYTICS_UUID_KEY, uuid);
    }

    this.uuid = uuid;

    return uuid;
  }

  static async sendEvent(
    event: EAnalyticsEvent,
    value: object = {},
    version: number = 1,
    count: number = 1
  ) {
    if (process.env.MIX_ENV === 'local') {
      console.log('Analytics Event:', event, value);
      return;
    };

    const product = EAnalyticsProduct.streamlabsStudio;
    const uuid = await this.getUuid();
    const eventData: IEventData = {
      product,
      event,
      value,
      version,
      count,
      uuid,
    };

    if (this.userModule.user?.id) eventData.user_id = this.userModule.user.id;
    if (this.userModule.abGroup) (eventData.value as any).abGroup = this.userModule.abGroup;

    const data = {
      events: [eventData]
    };

    await HttpHelper.post(this.endpoint, data, {
      background: true,
      ignoreError: true,
    });
  }
}